import type { AdminSettings } from "../../../types/adminsettings.types";

type GetEstimatedProductionDaysParams = {
	adminSettings?: AdminSettings;
	isPhysical: boolean;
	isPriority: boolean;
	isRework: boolean;
};

export const getEstimatedProductionDays = ({
	adminSettings,
	isPhysical,
	isPriority,
	isRework,
}: GetEstimatedProductionDaysParams) => {
	if (adminSettings === undefined) {
		return 0;
	}

	let days = 0;

	if (isPhysical && isRework === false) {
		days += adminSettings.meanDaysReceiptTime;
	}

	if (isPriority) {
		days += adminSettings.meanDaysExpressProductionTime;
	} else {
		days += adminSettings.meanDaysProductionTime;
	}

	days += adminSettings.meanDaysShippingTime;

	return days;
};
